export const DataDogContextKeys = {
  ApplicationId: 'applicationId' as const,
  DeviceId: 'deviceId' as const,
  OS: 'os' as const,
  PlatformVersion: 'platformVersion' as const,
  BuildNumber: 'buildNumber' as const,
  AppVersion: 'appVersion' as const,
} as const